<script>
import BaseField from '@/components/BaseField.vue';
import form from '@/utils/form';
import api from '@/api/task';

export default {
  name: 'TaskAddForm',
  components: { BaseField },
  props: {
    stage: Object,
  },
  data() {
    return {
      name: form.createFieldObject('string', 'Название задачи', '', { required: 'Укажите название' }),
    };
  },
  mounted() {
    this.$refs.field.focus();
  },
  methods: {
    async add() {
      form.validateField(this, 'name');

      if (this.name.error) return;

      const created = await api.create({ name: this.name.value, stage: this.stage['@id'] }, true);
      const createdWithAuthor = { ...created, author: this.$store.state.auth.user };
      this.$store.commit('taskList/set', [...this.$store.state.taskList.items, createdWithAuthor]);

      this.hide();
    },
    hide() {
      form.clear({ name: this.name });
      this.$emit('hide');
    },
  },
};
</script>

<template lang="pug">
form.task-add-form(@submit.prevent="add")
  BaseField.field(v-model="name.value" v-bind="name" ref="field")
  Btn.btn(green lg @click="add") Сохранить
  Btn.btn(grey lg @click="hide") Отменить
</template>

<style scoped lang="scss">
.task-add-form {
  display: flex;
  gap: 20px;
}

.field {
  flex-grow: 1;
}

@media (max-width: 600px) {
  .task-add-form {
    flex-wrap: wrap;
  }

  .field {
    width: 100%;
  }

  .btn {
    flex-grow: 1;
  }
}
</style>
